// Library
import React, { useState } from 'react';
import { Close } from '@public';
import { useDropzone } from 'react-dropzone';

// CSS Style for this module
import styles from './DragAndDrop.module.scss';

interface DragAndDropProps {
	/**
	 * Custom styles of the container
	 */
	customStyles?: string;
	/**
	 * Indicative text that is displayed within the drag and drop box
	 */
	message?: string;
	/**
	 * onChange function for keeping track field value
	 * debounce is built in
	 */
	handleChange?: (file: File | undefined, errors?: Error[]) => void;
}

export function DragAndDrop({
	customStyles,
	message = 'Drag and drop a file here, or click to select file',
	handleChange = () => {
		return;
	},
}: DragAndDropProps) {
	const [file, setFile] = useState<File | undefined>();
	const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
		accept: { 'image/*': [] },
		onDrop: (selectedFiles: File[]) => {
			setFile(selectedFiles[0]);
			handleChange(selectedFiles[0]);
		},
	});

	const styleTest = [
		styles.baseStyle,
		isFocused ? styles.focusedStyle : '',
		isDragAccept ? styles.acceptStyle : '',
		isDragReject ? styles.rejectStyle : '',
	].join(' ');

	const removeFile = () => {
		setFile(undefined);
		handleChange(undefined, undefined);
	};

	return (
		<div className={customStyles}>
			<div {...getRootProps()} className={styleTest}>
				<input {...getInputProps()} />
				<p className={styles.message}>{message}</p>
			</div>
			{file ? (
				<div className={styles['image-container']}>
					<Close customStyles={styles.icon} handleClick={removeFile} />
					<picture>
						<img
							src={URL.createObjectURL(file)}
							className={styles.image}
							alt={file.name}
							title={file.name}
						/>
					</picture>
				</div>
			) : (
				<></>
			)}
		</div>
	);
}
